import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Intervention} from '../models/intervention.model';

@Injectable({
  providedIn: 'root'
})
export class InterventionService {

  private api:string = environment.api+'/interventions';

  constructor(private http: HttpClient) { }

  public getAllInterventions(pageNo:number,pageSize:number){
    return this.http.get(this.api+'/getAll?pageNo='+pageNo+'&pageSize='+pageSize);
  }
  public findAllUnreportedIntervention(){
    return this.http.get(this.api+'/getAllInterventions');
  }
  public findRoomsOfInterventionByRoomType(roomType:string){
    return this.http.get(this.api+'/findRoomsOfInterventionByRoomType/'+roomType);
  }

  public createIntervention(intervention:Intervention){
    return this.http.post(this.api,intervention);
  }

  public updateIntervention(intervention:Intervention){
    return this.http.put(this.api,intervention);
  }

  public deleteIntervention(intervention:Intervention){
    return this.http.delete(this.api+'/'+intervention.interventionId);
  }

  public getTodayIntervention(){
    return this.http.get(this.api+'/todayIntervention');
  }

  public createEquipmentIntervention(equipmentId : number){
    return this.http.post(this.api+'/equipement',equipmentId)
  }

  public getReportedInterventions(){
    return this.http.get(this.api+'/reportedInterventions')
  }
}
